import Config from "../Config";

import { Fragment, useEffect, useRef, useState } from "react";

import MyRoute from "../helpers/MyRoute";
import MenuTop from "./MenuTop";
import MenuLeft from "./MenuLeft";
import HomeView from "../module/home/HomeView";
import CalculateView from "../module/calculate/CalculateView";
import MainTools from "./MainTools";
import RaportView from "../module/raport/RaportView";
import SettingsView from "../module/settings/SettingsView";



function MainView(props)
{     
        var startModule = MyRoute( window.location.href, "module" );
        var startView = MyRoute( window.location.href, "view" );
        var startId = MyRoute( window.location.href, "id" );

        if(startModule == null || startModule == undefined) startModule = "home";
        if(startView == null || startView == undefined) startView = "clients";
        if(startId == null || startId == undefined) startId = "-1";

        const [loc, setLoc] = useState({
            menuSelected: startModule,
            viewSelected: startView,
            startId: startId
        });

       


        const [globalVariable, setGlobalVariable]  = useState({           
        });

        var tmpGlobal = globalVariable;
        
 
        const dashboardRef = useRef();

       
        const progressRef = useRef();

        const dlgErrorRef = useRef();
        const dlgErrorTitleRef = useRef();
        const dlgErrorMsgRef = useRef();

        const dlgOkRef = useRef();
        const dlgOkTitleRef = useRef();
        const dlgOkMsgRef = useRef();

        const dlgYesNoRef = useRef();
        const dlgYesNoTitleRef = useRef();
        const dlgYesNoMsgRef = useRef();


        const dlgDownloadRef = useRef();
        const dlgDownloadCancelRef = useRef();
        const dlgDownloadOkRef = useRef();
        const dlgDownloadProgressRef = useRef();
        const dlgDownloadInfo0Ref = useRef();
        const dlgDownloadInfoRef = useRef();


        const [alertx, setAlertX] = useState(null);
        const [alertx_code, setAlertXCode] = useState('');
        const [alertx_crypt, setAlertXCrypt] = useState('');
        const [alertx_msg, setAlertXMsg] = useState('');

        var handleFunction = null;
        var handleFunctionParam = null;
        var handleActualKeyListener = null;


 

        //------------------------------------------------            

        const changeMenuStatus = (visible) => {
           

              //  dlgErrorRef.current.classList.remove('goHide');
              if(Config.env) console.log("mainView changeMenuStatus ",visible);

              if(visible != undefined && visible.target != null)
              {
                    var isE = dashboardRef.current.classList.contains('fullscreen');

                    if(isE)
                    {
                        dashboardRef.current.classList.remove('fullscreen');
                    }else  dashboardRef.current.classList.add('fullscreen');

              }else 
              {
                if(visible == 1) dashboardRef.current.classList.remove('fullscreen');
                if(visible == 0) dashboardRef.current.classList.add('fullscreen');

              }

                


        }

        //------------------------------------------------
    
        const clickMenu = (item, item2, item3) => {
            
            sessionStorage.setItem("click-action-count", 0); //wyzeruj licznik zbyt duzej ilosci wywołań..
             
            if(Config.env == 'dev') console.log("clickMenu " + item + " " + item2 + " " + item3);

            setLoc( { ...loc , ["menuSelected"]:item, ["viewSelected"]:item2,["startId"]:item3  } );        
            
 


            var url = "";
            if(item != undefined && item.length > 0) url = url + "/module/"+item;
            if(item2 != undefined && item2.length > 0) url = url + "/view/"+item2;      
            window.history.pushState({page: url}, "", url);  

            props.goRefresh(); 
            

            //scroll to Top webSite
            setTimeout( ()=> { 

                var rightContent = document.getElementsByClassName("econtent");
                if(rightContent.length > 0)
                {
                    console.log("goTop");             

                    window.scrollTo({
                        //'behavior': 'smooth',
                        'behavior': 'auto',
                        'left': 0,
                        'top': rightContent.offsetTop - 0
                      });

                }
                
            }, 200 );

        }        


        const quickGo = (e) => {

            
            var module = e.target.getAttribute("module");
            var view = e.target.getAttribute("view");
            var id = e.target.getAttribute("id");

            var mTop = e.target.getAttribute("mTop");

            if(module == null )
            {
                if(e.target.parentElement != null)
                {
                     module = e.target.parentElement.getAttribute("module");
                     view = e.target.parentElement.getAttribute("view");
                     id = e.target.parentElement.getAttribute("id"); 
                }
                
            }

            clickMenu(module,view,id);

            if(Config.env == 'dev' )console.log("mtop", mTop, e.target, e.current);
            

            

            if(module == "men")
            {
                changeMenuStatus(0);
            }

            if(module == "home" && view == "start")
            {
                changeMenuStatus(1);
            }
        }

        //------------------------------------------------
        //------------------------------------------------
        window.addEventListener('beforeunload', function(e) {

                    if(Config.env == 'dev') console.log("MainView - window.beforeunload");
                    /*
                    var myPageIsDirty = true; //you implement this logic...
                    if(myPageIsDirty) {
                    //following two lines will cause the browser to ask the user if they
                    //want to leave. The text of this dialog is controlled by the browser.
                    e.preventDefault(); //per the standard
                    e.returnValue = ''; //required for Chrome
                    }
                    //else: user is allowed to leave without a warning dialog
                    */
        });


        window.onpopstate = function(event) 
        {            
                if(event){ 
                     if(Config.env == 'dev')  console.log("MainView - window.onopopstate, goBack or goNext" + event + " ," +window.location );
                }
                else{ 
                     if(Config.env == 'dev')  console.log("MainView - window.onopopstate, clickLink " + event + " ," + window.location);              
                }  


                var moduleX = MyRoute( window.location.href, "module" );               
                var viewX = MyRoute( window.location.href, "view" );
    
                setLoc({...loc, ["menuSelected"]:moduleX, ["viewSelected"]:viewX   });     
                props.goRefresh();      
        }


       
        //------------------------------------------------
        //------------------------------------------------
        //------------------------------------------------        
    
        const showProgressBar = () => {             
               if(progressRef != null && progressRef.current != undefined )   progressRef.current.classList.remove('goHide');          
        }
        
        const hideProgressBar = () => {                 
              if(progressRef != null && progressRef.current != undefined  )   progressRef.current.classList.add('goHide');
        }

        //------------------------------------------------
        //------------------------------------------------
    
            const writeFilter = (uq_name, val) => {

                    var filterTab = {};        

                    var tmp = sessionStorage.getItem("filter_tab");
                    if(tmp != null && tmp != undefined)
                        {               
                            filterTab = JSON.parse(tmp);                    
                        }                                
            
                    var newTab = {[uq_name]:val}   ;
                    var dt = {...filterTab,...newTab};
                        
                    sessionStorage.setItem('filter_tab', JSON.stringify(dt) );

                // console.log("writeFilter", uq_name, val, dt);
                }
                
                const readFilter = (uq_name, def) => {

                    var filterTab = [];

                    var tmp = sessionStorage.getItem("filter_tab");
                    if(tmp != null && tmp != undefined)
                        {
                            filterTab = JSON.parse(tmp);
                        }

                    if(filterTab[uq_name] != null && filterTab[uq_name] != undefined )    
                        {
                            var tx = filterTab[uq_name];
                            if(tx != undefined && tx != null) return tx;
                        }

                    return def;
                }

        //------------------------------------------------
        //------------------------------------------------

        const showDialog = (title, msg, type, callback, param ) => {

            Array.from(document.querySelectorAll('input')).forEach(el => el.blur())

            if(type == 'OK' || type == 'ok')
            {
                     if(dlgOkRef != null && dlgOkRef.current != undefined  ) 
                     {
                          dlgOkRef.current.classList.remove('goHide');
                          dlgOkTitleRef.current.innerHTML = title;
                          dlgOkMsgRef.current.innerHTML = msg;
                     }
            }

            if(type == 'ERROR' || type == 'error')
            {
                     if(dlgErrorRef != null && dlgErrorRef.current != undefined  ) 
                     {
                          dlgErrorRef.current.classList.remove('goHide');
                          dlgErrorTitleRef.current.innerHTML = title;
                          dlgErrorMsgRef.current.innerHTML = msg;
                     }
            }

            if(type == 'YESNO' || type == 'yesno')
            {
                     if(dlgYesNoRef != null && dlgYesNoRef.current != undefined  ) 
                     {
                          dlgYesNoRef.current.classList.remove('goHide');
                          dlgYesNoTitleRef.current.innerHTML = title;
                          dlgYesNoMsgRef.current.innerHTML = msg;                              
                     }
            }

            handleFunction = callback;
            handleFunctionParam = param;
            handleActualKeyListener = window.onkeydown;

            if(Config.env == 'dev') console.log("Dlg keyListener on");
            window.onkeydown = function (e) 
            {                        
                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(Config.env == 'dev') console.log("Dialog listener",code, e.target.nodeName); 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 27)  //esc
                        {
                              closeDialog("none");
                        } 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 84 )  //t
                        {
                              closeDialog("yes");
                        } 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 78 )  //n
                        {
                             closeDialog("no"); 
                        } 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 13 )  //enter
                        {
                             closeDialog("ok"); 
                        } 
            }

            if(Config.env == "dev") console.log("MainView showDialog " + msg);
        }  

     


        const closeDialog = (e) => {

             if(dlgErrorRef != null && dlgErrorRef.current != undefined  )   dlgErrorRef.current.classList.add('goHide');
             if(dlgOkRef != null && dlgOkRef.current != undefined  )   dlgOkRef.current.classList.add('goHide');
             if(dlgYesNoRef != null && dlgYesNoRef.current != undefined  )   dlgYesNoRef.current.classList.add('goHide');

             var type = "none";

             if(e != undefined &&  e.target != undefined)
             {
                type = e.target.getAttribute('atr-type');               
             }else 
             {                
                type = e;  //przekazane jako tekst..                 
             }         

            if(Config.env == "dev") console.log("MainView showDialog res:" + type);               

             //oddaj listener..             
             if(handleActualKeyListener != null) window.onkeydown = handleActualKeyListener;             

             if(handleFunction != null)
             {
                    handleFunction(type, handleFunctionParam);
             }
             
        }


        //------------------------------------------------   
    
        const downloadDialog = ( links ) => {
                     
                console.log("Linki", links);

                dlgDownloadInfo0Ref.current.innerHTML = "Trwa pobieranie pliku...";

                dlgDownloadRef.current.classList.remove('goHide');                          
                dlgDownloadCancelRef.current.classList.remove('goHide');                          
                dlgDownloadOkRef.current.classList.add('goHide');                                    

                dlgDownloadProgressRef.current.classList = null;
                dlgDownloadProgressRef.current.classList.add('download_progress_1');  

                var inx = 0;
                var total = -1;
                var actual = -1;

                
                const getFile = () => {

                    if(inx >= links.length) 
                    {                        
                        return;
                    }

                    dlgDownloadInfoRef.current.innerHTML = links[inx].link + "[ " + JSON.stringify(links[inx].params) + " ]";

                    dlgDownloadInfo0Ref.current.innerHTML = "Trwa pobieranie pliku " +  links[inx].fileName + " ...";

                    dlgDownloadRef.current.classList.remove('goHide');                          
                    dlgDownloadCancelRef.current.classList.remove('goHide');                          
                    dlgDownloadOkRef.current.classList.add('goHide');                                    

                    dlgDownloadProgressRef.current.classList = null;
                    dlgDownloadProgressRef.current.classList.add('download_progress_1');  
                    


                        var blob;
                        var xmlHTTP = new XMLHttpRequest();
                        xmlHTTP.open('POST',  Config.master +  links[inx].link , true);


                        xmlHTTP.setRequestHeader("Content-Type", 'application/json');
                        xmlHTTP.setRequestHeader("X-Api-Key",props.userData.apiKey);
                        xmlHTTP.setRequestHeader("_fak_sprzedawcy_id_",props.userData.fak_sprzedawcy_id);
                        xmlHTTP.setRequestHeader("_sec_key_",  Config.genXKey()  );                      
                        xmlHTTP.responseType = 'arraybuffer';

                        xmlHTTP.onload = function(e) {                                                   
 
                            

                        };

                        xmlHTTP.onreadystatechange = function() {
                                                       

                            if (xmlHTTP.readyState == XMLHttpRequest.DONE) {
                                //console.log(this.response);

                                try{

                                     var tab = JSON.parse(this.response);
                                        if(tab["ERROR"])
                                        {
                                            dlgDownloadRef.current.classList.add('goHide');   
                                            showDialog("Ups", "Nie można pobrać pliku (" + this.response + ")", "error", ()=>{}, "" );
                                            return;
                                        }

                                }catch(err) {}                               

                                if(actual < 1)
                                {
                                    dlgDownloadRef.current.classList.add('goHide');   
                                    showDialog("Ups", "Nie można pobrać pliku (" + this.response + ")", "error", ()=>{}, "" );
                                    return;
                                }


                               var blob = new Blob([this.response] );  
                               // var blob = new Blob([this.response], {type: 'application/pdf'} );  
                                console.log(this.response); 

                                var fileName = links[inx].fileName;

                                var url = window.URL.createObjectURL(blob);
                         
                                dlgDownloadProgressRef.current.classList.add('goHide');    
                                dlgDownloadInfoRef.current.classList.add('goHide');    
                                dlgDownloadCancelRef.current.classList.add('goHide');   

                                dlgDownloadInfo0Ref.current.innerHTML = "Pobieranie pliku zostało ukończone ("+ total  +"b)";

                                dlgDownloadOkRef.current.classList.remove('goHide');    
                                dlgDownloadOkRef.current.href = url;
                                //dlgDownloadOkRef.current.href = "data:application/pdf;base64," + btoa( this.response);
                                dlgDownloadOkRef.current.download = fileName;

                                inx++;
                                getFile();
                            }

                            if(total > -1 && actual > -1)
                            {
                                var proc = (100 * actual) / total;
                                if(Config.env == 'dev') console.log("Proc", proc)

                                dlgDownloadProgressRef.current.style.width = proc+"%";                                
                            }
                        }

                        xmlHTTP.onprogress = function(pr) {
                            //pr.loaded - current state
                            //pr.total  - max
                            console.log("Total: " + pr.total);
                            console.log("Loaded: " + pr.loaded);
                            actual = pr.loaded;
                            total = pr.total;
                        };
                        xmlHTTP.onloadend = function(e){
                           
                         
                            
                        }
                        xmlHTTP.send(JSON.stringify(links[inx].params) );

                        dlgDownloadCancelRef.current.onclick = () => {
                            
                            console.log("cancel..");
                            xmlHTTP.abort();

                        }
                    
                }
                
                getFile();

        }

        const downloadCancel = ( links ) => {

                          dlgDownloadRef.current.classList.add('goHide');                          
        }

        //------------------------------------------------   
    
        const keyListener = (e) => {

              var code = e.keyCode ? e.keyCode : e.which;    

              if(Config.env == 'dev') console.log("mainView, keyListener ", code);

                        if(e.shiftKey && e.target.nodeName.toLowerCase() == "body"  ) 
                        {                             
                            if(code == 66 )  clickMenu("home","locks","shortkey"); //b
                            if(code == 70 )  clickMenu("calculate","invoices","shortkey"); //f
                            if(code == 75 )  clickMenu("home","clients","shortkey"); //k
                            if(code == 81 ) 
                            {
                                 showDialog( "Ups!", "Czy na pewno chcesz wyjść z panelu?" , "yesno" ,  (reqP)=>{
                                      if(reqP == "yes")   props.logout();
                                 } );  
                                //q
                            }
                            if(code == 72 )  clickMenu("calculate","history","shortkey"); //history
                            if(code == 80 )  clickMenu("calculate","transfers","shortkey"); //p przelewy
                            if(code == 82 )  clickMenu("calculate","calculate","shortkey"); //r
                            if(code == 83 )  clickMenu("home","services","shortkey"); //s
                            if(code == 85 )  clickMenu("home","contracts","shortkey"); //k
                        }

                        if (e.target.nodeName.toLowerCase() == "body" && code === 13) { //enter                         
                                closeDialog();
                        }else

                        if (e.target.nodeName.toLowerCase() == "body" && code === 38) { //up key                            

                        }else
                        if (e.target.nodeName.toLowerCase() == "body" && code === 40) { //down key

                        }else
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                //e.target.blur();
                        } else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                               // props.onBack();                               
                        } 


        }

        //------------------------------------------------   
        //------------------------------------------------   
 

        //------------------------------------------------
        //------------------------------------------------


        var mainView = {   
           
            menuSelected: loc.menuSelected,
            viewSelected: loc.viewSelected,
            idSelected: loc.startId,
           
            changeMenuStatus: changeMenuStatus,

            clickMenu: clickMenu,
            quickGo: quickGo, 


            changeProfile: props.changeProfile,


            showProgress: showProgressBar,
            hideProgress: hideProgressBar,

            writeFilter: writeFilter,
            readFilter: readFilter,

            showDialog: showDialog,
            downloadDialog: downloadDialog,

            keyListener: keyListener,
        }



        var content         = "Wybierz opcje z menu";     
        var dialog          = null;
        var dialogProgress  = null;


        switch(loc.menuSelected)
        {
            case 'home': 
            {
                content = <HomeView userData={props.userData} mainView={mainView}  keyListener={keyListener}  />
            }break;

            case 'calculate': 
            {
                content = <CalculateView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

            case 'raport': 
            {
                content = <RaportView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

            case 'settings': 
            {
                content = <SettingsView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

        }

 
        //-----------------------------------------------------
       

        //-----------------------------------------------------
        //-----------------------------------------------------

        useEffect( ()=>{

             if(Config.env == "dev") console.log("MainView.js, listener on");
                window.onkeydown = keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("MainView.js, listener off");      
                    window.onkeydown = null;
                };

        } );

        //-----------------------------------------------------        

    return (
            <div className={ "dashboard " } ref={dashboardRef}>                     


                    <MenuTop  userData={props.userData} mainView={mainView} logout={props.logout}  />



                    <MenuLeft userData={props.userData}  mainView={mainView}   />

                    <div className="mainContent">                  
                        {content}
                    </div>


                    <div onClick={props.logout}>logout</div>



                    <div className="dlg_window shadowx z-max goHide" ref={dlgDownloadRef}>
                            <div className="dlg_title" >Menadżer Pobierania</div>
                            <div className="dlg_msg">
                                  <div  ref={dlgDownloadInfo0Ref}>
                                      Trwa pobieranie pliku...
                                  </div>
                                  <br/>
                                  <div ref={dlgDownloadInfoRef}>...</div>
                                  <br/>
                                  <div className="download_bar">
                                        <div className="download_progress_1" ref={dlgDownloadProgressRef}></div>
                                  </div>
                            </div>
                            <div className="dlg_btn">
                                <div className="btn goHide" atr-type="yes" onClick={downloadCancel} ref={dlgDownloadCancelRef}>Przerwij</div>                             
                                <a href="" className="btn goHide" atr-type="yes" onClick={downloadCancel} ref={dlgDownloadOkRef}>Gotowe - zapisz na komputerze</a>                             
                            </div>
                    </div>

                   

                    <div className="progressBar goHide" ref={progressRef}></div>
                 



                    <div className="dlg_window shadowx bg_error z-max goHide" ref={dlgErrorRef}>
                            <div className="dlg_title" ref={dlgErrorTitleRef}>....</div>
                            <div className="dlg_msg" ref={dlgErrorMsgRef}>.a..</div>
                            <div className="dlg_btn">
                                <div className="btn" atr-type="ok" onClick={closeDialog}>Zamknij [enter]</div>                        
                            </div>
                    </div>

                    <div className="dlg_window shadowx z-max goHide" ref={dlgOkRef}>
                                <div className="dlg_title" ref={dlgOkTitleRef}>...</div>
                                <div className="dlg_msg" ref={dlgOkMsgRef}>.b..</div>
                                <div className="dlg_btn">
                                    <div className="btn" atr-type="ok" onClick={closeDialog}>OK [enter]</div>
                                </div>
                        </div>



                    <div className="dlg_window shadowx z-max goHide" ref={dlgYesNoRef}>
                            <div className="dlg_title" ref={dlgYesNoTitleRef}>....</div>
                            <div className="dlg_msg" ref={dlgYesNoMsgRef}>..c..</div>
                            <div className="dlg_btn">
                                <div className="btn" atr-type="yes" onClick={closeDialog}>Tak [t]</div>
                                &nbsp; &nbsp;
                                <div className="btn" atr-type="no" onClick={closeDialog}>Nie [n]</div>
                            </div>
                    </div>


                  



            </div>
    )

}

export default MainView;


